module.exports = __webpack_public_path__ + "img/joker_sad.807b64c9.png";